<div class="modal-header">
  <h4 class="modal-title">
    <b> {{modalProps.title}} </b>
  </h4>
  <span
    type="button"
    class="close btn"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    &times;
  </span>
</div>
<div class="container modal-body">
  <div class="row mx-2 pb-3 flex-row justify-content-center">
    <div class="col-md-2" *ngIf="modalProps.icon">
      <i class="fa fa-4x" [ngClass]="modalProps.icon"></i>
    </div>
    <div class="col-md-10 flex-column" [ngClass]="modalProps.icon ? 'align-items-left' : 'align-items-center'">
      <strong class="d-inline-block" data-test-selector="modal-message">{{ modalProps.message }}</strong>
      <small class="d-inline-block text-muted" data-test-selector="modal-submessage">{{ modalProps.subMessage }}</small>
    </div>
  </div>

  <div class="modal-footer">
    <ng-container *ngFor="let button of modalProps.buttons">
      <button 
        type="button"
        [ngClass]="button.style"
        (click)="button.action()">
        {{button.text}}
      </button>
    </ng-container>
  </div>
</div>
